import { render } from "./AddPermission.vue?vue&type=template&id=28591ebe&scoped=true"
import script from "./AddPermission.vue?vue&type=script&lang=js"
export * from "./AddPermission.vue?vue&type=script&lang=js"

import "./AddPermission.vue?vue&type=style&index=0&id=28591ebe&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28591ebe"]])

export default __exports__